// Espera a que todo el HTML esté cargado
document.addEventListener('DOMContentLoaded', () => {

  // 1. Registra el plugin de ScrollTrigger con GSAP
  gsap.registerPlugin(ScrollTrigger);

  // 2. Selecciona tus elementos
  const triggerElement = document.querySelector('.footer-logo-container');
  const targetElement = document.querySelector('.footer-animated-text');

  // 3. ¡Importante! Comprueba que los elementos existan en esta página
  if (triggerElement && targetElement) {

    // 4. Creamos la animación GSAP (es importante no usar gsap.from directamente, sino un timeline o un tween)
    const slideInTween = gsap.from(targetElement, {
      // Estado inicial (desde donde anima)
      x: '100%',     // Empieza 100% a la derecha
      
      // Configuración de la animación
      duration: 1.5,
      ease: 'power3.out',
      // No incluimos scrollTrigger aquí. Lo añadiremos después.
    });

    // 5. Aplicamos ScrollTrigger con las acciones de reinicio
    ScrollTrigger.create({
        trigger: triggerElement,   // El disparador es el contenedor del SVG
        start: 'bottom bottom',          // Empieza cuando el 80% superior del trigger entra en la pantalla
        
        // ACCIÓN CLAVE: 
        // play:  Al entrar (start) -> Inicia la animación (slideInTween)
        // pause: Al salir hacia abajo (end) -> Pausa la animación
        // reverse: Al entrar de nuevo hacia arriba (end) -> Invierte la animación
        // reset: Al salir hacia arriba (start) -> Resetea la animación a su estado inicial 'from' (x: 100%)
        // Usaremos 'play none none reverse' si queremos que se ejecute una vez y se invierta al volver.
        // O usaremos 'play none none reset' para que se ejecute y luego se resetea si se vuelve a hacer scroll.
        // O, para el comportamiento de "resetear cada vez que sale", usaremos:
        
        // Acciones: onEnter, onLeave, onEnterBack, onLeaveBack
        toggleActions: 'play reverse play reverse', // Entra (Play), Sale (Reverse), Vuelve a entrar (Play), Vuelve a salir (Reverse)

        
        // Si quieres que se ejecute al entrar y se invierta visualmente al salir:
        toggleActions: 'play reverse play reverse', 
        
        // Adjuntamos el tween que definimos arriba
        animation: slideInTween
    });

  } else {
     console.log('Elementos del footer para animar no encontrados en esta página.');
  }
});